import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode, TextareaHTMLAttributes, useState } from 'react';

import styles from './styles.module.scss';

interface Props extends TextareaHTMLAttributes<HTMLInputElement|HTMLTextAreaElement> {
    showLength?: boolean;
    textAlign?: 'left' | 'center' | 'right';
    value?: string,
    setValue?: (value: string) => void;
    as?: 'input'|'textarea';
    min?: number;
    max?: number;
    trailing?: ReactNode;
    helperText?: string;
}
function TextField(props: Props) {
  const {
    showLength, textAlign, setValue, value, maxLength, min, max, as: Component = 'input',
    onChange, trailing, helperText,
    className, ...rest
  } = props;
  const [length, setLength] = useState<number>(0);
  return (
        <Container>
            <div className={styles.container}>
                <Component className={`${styles.input} ${className}`}
                           value={value}
                           maxLength={maxLength}
                           min={min}
                           max={max}
                           onChange={(e) => {
                             setValue?.(e.target.value);
                             setLength(e.target.value.length);
                             onChange?.(e);
                           }}
                           style={{ textAlign }}
                           {...rest} />
                {showLength && (
                    <span className={`${styles.count} ${Component === 'textarea' ? styles.textarea : ''}`}>
                    {length} /  {maxLength}
                </span>
                )}
                {trailing && (
                    <div className={styles.trailing}>
                        {trailing}
                    </div>
                )}
            </div>
            {helperText && (
                <Text color={colors.gray6} size='s'>{helperText}</Text>
            )}
        </Container>
  );
}

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 4px;
`;

export default TextField;
